import User from "@/views/PCView/user/index.vue"
import Authentication from "@/views/PCView/user/view/renzheng/index.vue"

export default [
  {
    path: "/user",
    name: "user",
    component: User,
    children: [
      {
        path: "/user/authentication",
        name: "userAuthentication",
        meta: {
          noAuthority: true,
        },
        component: Authentication,
      },
      {
        path: "/user/mytickets",
        name: "usermyTickets",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/myTickets/index.vue"], resolve),
      },
      {
        path: "/user/review",
        name: "userReview",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/shenhe/review.vue"], resolve),
      },
      {
        path: "/user/contentMrg",
        name: "userContentMrg",
        component: (resolve) =>
          require(["@/views/PCView/user/view/contentMrg/index.vue"], resolve),
      },
      {
        path: "/user/meetMan",
        name: "userMeetingManagement",
        component: (resolve) =>
          require(["@/views/PCView/user/view/meetMan/index.vue"], resolve),
      },
      {
        path: "/user/courseMan",
        name: "userCourseManagement",
        component: (resolve) =>
          require(["@/views/PCView/user/view/courseMan/index.vue"], resolve),
      },
      {
        path: "/user/periodicalRz",
        name: "userPeriodicalRz",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/periodicalRz/index.vue"], resolve),
      },
      {
        path: "/user/messageMrg",
        name: "userMessageMrg",
        component: (resolve) =>
          require(["@/views/PCView/user/view/messageMrg/index.vue"], resolve),
      },
      {
        path: "/user/msg",
        name: "userMsg",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/msg/index.vue"], resolve),
      },
      {
        path: "/user/collectMrg",
        name: "userCollect",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/collectMrg/index.vue"], resolve),
      },
      {
        path: "/user/setting",
        name: "userSetting",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/setting/index.vue"], resolve),
      },
      {
        path: "/user/letter",
        name: "userLetter",
        component: (resolve) =>
          require(["@/views/PCView/user/view/letter/index.vue"], resolve),
      },
      {
        path: "/user/scholar",
        name: "userScholar",
        component: (resolve) =>
          require(["@/views/PCView/user/view/scholar/index.vue"], resolve),
      },
      {
        path: "/user/history",
        name: "userHistory",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/history/index.vue"], resolve),
      },

      {
        path: "/user/magazine",
        name: "userMagazine",
        component: (resolve) =>
          require(["@/views/PCView/user/view/magazine/index.vue"], resolve),
      },

      {
        path: "/user/organization",
        name: "userOrganization",
        component: (resolve) =>
          require(["@/views/PCView/user/view/organization/index.vue"], resolve),
      },
      {
        path: "/user/sonUser",
        name: "userSonUser",
        component: (resolve) =>
          require(["@/views/PCView/user/view/sonUser/index.vue"], resolve),
      },
      {
        path: "/user/scholarRz",
        name: "userScholarRz",
        meta: {
          noAuthority: true,
        },
        component: (resolve) =>
          require(["@/views/PCView/user/view/scholarRz/index.vue"], resolve),
      },
      {
        path: "/user/vedio",
        name: "userVedio",
        component: (resolve) =>
          require(["@/views/PCView/user/view/video/index.vue"], resolve),
      },
      {
        path: "/user/zghmrg",
        name: "userZghmrg",
        component: (resolve) =>
          require(["@/views/PCView/user/view/zghMrg/index.vue"], resolve),
      },
    ],
  },
  {
    path: "/paperForm",
    name: "userpaperForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/PaperForm.vue"], resolve),
  },
  {
    path: "/informationForm",
    name: "userinformationForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/InformationForm.vue"], resolve),
  },
  {
    path: "/abstractForm",
    name: "userabstractForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/AbstractForm.vue"], resolve),
  },
  {
    path: "/reportForm",
    name: "userreportForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/ReportForm.vue"], resolve),
  },
  {
    path: "/zghForm",
    name: "userzghForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/ZghForm.vue"], resolve),
  },
  {
    path: "/monographForm",
    name: "usermonographForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/MonographForm.vue"], resolve),
  },
  {
    path: "/conferenceForm",
    name: "userconferenceForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/ConferenceForm.vue"], resolve),
  },
  {
    path: "/courseForm",
    name: "usercourseForm",
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/courseForm.vue"], resolve),
  },
  // 资讯预览
  {
    path: '/previewinformation',
    name: 'userpreviewinformation',
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/preview/previewInformation.vue"], resolve),
  },
  // 资讯预览
  {
    path: '/previewCourse',
    name: 'userpreviewCourse',
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/preview/coursePreview.vue"], resolve),
  },
  // 论文预览
  {
    path: '/paperpreview',
    name: 'userpaperpreview',
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/preview/paperPreview.vue"], resolve),
  },
  // 征稿函预览
  {
    path: '/fillingpreview',
    name: 'userfillingpreview',
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/preview/fillingPreview.vue"], resolve),
  },
  // 专著预览
  {
    path: '/bookpreview',
    name: 'userbookpreview',
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/preview/bookPreview.vue"], resolve),
  },
  // 会议预览
  {
    path: '/conferencepreview',
    name: 'userconferencepreview',
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/preview/conferencePreview.vue"], resolve),
  },
  // 报告预览
  {
    path: '/reportpreview',
    name: 'userreportPreview',
    component: (resolve) =>
      require(["@/views/PCView/user/view/form/preview/reportPreview.vue"], resolve),
  }
];
